function encodeParams(params) {
  let esc = encodeURIComponent

  return Object.keys(params)
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&')
}

class Client {
  constructor(host) {
    this.host = host
  }

  checkStatus(response) {
    if (response.status < 500) {
      return response
    }
    return Promise.reject({
      message: response.statusText,
      response: response
    })
  }

  get(path, query) {
    return fetch(this.host + '/api/v1/' + path + '.json?' + encodeParams(query))
      .then(this.checkStatus)
      .then(res => res.json())
  }
}

export default Client
